"use client"
import { parse } from "date-fns";
import { ProgramDatesContext } from "src/lib/contexts/ContextTypes";

type SingleDateProgramDatesWrapperProps = {
    children: React.ReactNode;
    selectedDate: string;
};

export default function SingleDateProgramDatesWrapper({ children, selectedDate }: SingleDateProgramDatesWrapperProps) {
    const _selectedDate = parse(selectedDate, "yyyy-MM-dd", new Date());

    return <ProgramDatesContext.Provider value={
        {
            selectedDate: _selectedDate,
            showingAllDates: false,
            setIsShowingAllDates: (isShowing) => { },
            setSelectedDate: (selectedDate) => { },
            showSelectDateDialog: false,
            setShowSelectDateDialog: (show) => { },
            setAvailableDates: (dates) => { },
            availableDates: [_selectedDate]
        }
    }>
        {children}
    </ProgramDatesContext.Provider>;
}